module.exports = __webpack_public_path__ + "f2b28ba2967f927a57e8fbf554d318a3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/Foto_Manja_Herrmann-8438.jpg
// module id = 615
// module chunks = 0